import { createRouter, createWebHashHistory } from "vue-router";
import DefaultPage from "../layouts/default.vue";
import Login from "../layouts/login.vue";
import NotFound from "../layouts/404.vue";

const routes = [
  {
    path: "/",
    component: DefaultPage,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../pages/Index.vue"),
        meta: { auth: true, title: "Boshqaruv paneli" },
      },
      {
        path: "/about",
        name: "about",
        component: () => import("../pages/About.vue"),
        meta: { auth: true, title: "Biz haqimizda" },
      },
      {
        path: "/news",
        name: "news",
        component: () => import("../pages/News.vue"),
        meta: { auth: true, title: "Yangiliklar" },
      },
      {
        path: "/teatr",
        name: "teatr",
        component: () => import("../pages/Teatr.vue"),
        meta: { auth: true, title: "Spektakllar" },
      },
      {
        path: "/team",
        name: "team",
        component: () => import("../pages/Team.vue"),
        meta: { auth: true, title: "Jamoa" },
      },
      {
        path: "/gallery",
        name: "gallery",
        component: () => import("../pages/Gallery.vue"),
        meta: { auth: true, title: "Galereya" },
      },
      {
        path: "/messages",
        name: "messages",
        component: () => import("../pages/Messages.vue"),
        meta: { auth: true, title: "Xabarlar" },
      },
    ],
  },
  { path: "/login", name: "login", component: Login },
  { path: "/404", name: "404", component: NotFound },
  { path: "/:catchAll(.*)", redirect: "/404" },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // Himoyalangan sahifa, token yo'q -> login
  if (to.meta.auth && !token) {
    return next({ name: "login" });
  }
  // Login sahifasiga token bilan kirsa -> bosh sahifa
  if (to.name === "login" && token) {
    return next({ name: "home" });
  }
  next();
});

export default router;
